import artifact from '$houdini/artifacts/CreateCustomer'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateCustomerStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
